import { dispatchToast } from '@/ui-kit';

/** Autosave failures are the only save event worth interrupting the user for. */
export const updateFieldFailedAlert = () => {
  dispatchToast({
    variant: 'error',
    title: 'Update failed',
    duration: 4000,
  });
};
